/* eslint-disable complexity */

// Accordion
// ---------

function Accordion($accordion) {
  this.$accordion = $accordion;
  this.$tabs = this.$accordion.find('[role="tab"]');
  this.$panels = this.$accordion.find('[role="tabpanel"]');
  this.setup();
}

Accordion.prototype = {
  setup: function () {
    var constructor = this;

    this.$accordion
      .on('click', '[role="tab"]', function () {
        var $tab = $(this),
        state = $tab.is('[aria-expanded="true"]') ? 'close' : 'open';

        constructor.setPanelState(state, $tab);
      })
      .on('keydown', function (e) {
        constructor.onKeydown(e);
      });

    this.setPanelState('close');
  },

  teardown: function () {
    this.setPanelState('open');

    this.$accordion
      .off('click', '[role="tab"]')
      .off('keydown');
  },

  setPanelState: function (state, $tab) {
    var $panel = $tab ? this.getRelatedPanel($tab) : this.$panels;

    $tab = $tab || this.$tabs;
    state = state === 'open' ? 'true' : 'false';

    $tab.attr({
      'aria-expanded': state,
      'aria-selected': state
    });

    $panel.attr({
      'aria-expanded': state
    });
 },

  onKeydown: function (e) {
    var
    $target = $(e.target),
    $tabDestination,

    isModified = e.altKey || e.ctrlKey || e.shiftKey,
    isDownArrow = e.keyCode === 40,
    isLeftArrow = e.keyCode === 37,
    isRightArrow = e.keyCode === 39,
    isUpArrow = e.keyCode === 38,
    isTabFocused = $target.attr('role') === 'tab',
    tabDestination,
    tabIndex;

    if (
      isTabFocused &&
      !isModified &&
      (isDownArrow || isLeftArrow || isRightArrow || isUpArrow)
    ) {
      tabIndex = this.$tabs.index($target);
      tabDestination = tabIndex;

      if (
        (isUpArrow || isLeftArrow) &&
        tabIndex > 0
      ) {
        // move to previous tab
        tabDestination = tabIndex - 1;
      }

      if (
        (isDownArrow || isRightArrow) &&
        tabIndex < this.$tabs.length - 1
      ) {
        // move to next tab
        tabDestination = tabIndex + 1;
      }

      if (tabDestination !== tabIndex) {
        $tabDestination = this.$tabs.eq(tabDestination);
        $tabDestination.focus();
        e.preventDefault();
      }
    }

  },

  getRelatedPanel: function ($tab) {
    return this.$panels.filter('#' + $tab.attr('aria-controls'));
  }
};

// Exports
// -------

export default Accordion;



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/basics/accordion.js
 **/